import React from 'react';
import { useRouter } from 'next/router';

import cx from 'classnames';
import { CanvasFooter } from 'themes/canvas/components/CanvasFooter/CanvasFooter';
import { CanvasNavigation } from 'themes/canvas/components/Navigation/CanvasNavigation';

import { useBnplBanner } from 'hooks/bnpl/useBnplBanner';
import { useGGTheme } from 'hooks/theme/useGGTheme';

import { BuyNowPayLaterBanner } from 'routes/home/components/BuyNowPayLaterBanner/BuyNowPayLaterBanner';

import { BillboardNavigation } from '../BillboardNavigation/BillboardNavigation';

import s from './BillboardLayout.module.css';

interface TProps {
  children: React.ReactNode;
}

const BillboardLayout = ({ children }: TProps) => {
  const router = useRouter();
  const isBookingFlow =
    router.pathname === '/book' ||
    router.pathname === '/waitlist' ||
    router.pathname === '/multi-book';
  const isHomePage = router.pathname === '/';

  const isBookNow = router.pathname === '/booking-flow';
  const step = router.query.step;
  const { themeMode, theme } = useGGTheme();

  const isSandPalette = theme && theme.palette.name === 'Sand';

  const isDarkMode = themeMode === 'dark';

  let stepClass = '';

  if (typeof step === 'string') {
    stepClass =
      {
        'select-location': s.selectLocation,
        'select-time': s.selectTime,
        success: s.success,
        // Add more mappings as needed
      }[step] || '';
  }

  const {
    elementRef,
    showBanner,
    isLoading,
    bannerContainerStyle,
    onDismissBanner,
    isDismissed,
    bnplCapabilities,
  } = useBnplBanner();

  return (
    <div
      className={cx(s.billboard, {
        [s.lightMode]: isBookingFlow && !isDarkMode,
        [s.darkMode]: isBookingFlow && isDarkMode,
        [stepClass]: !!stepClass,
        [s.bookingFlowPage]: isBookNow,
        [s.bookingFlow]: isBookingFlow,
        [s.sandPalette]: isSandPalette,
      })}
      style={bannerContainerStyle}
    >
      {showBanner && (
        <BuyNowPayLaterBanner
          ref={elementRef}
          onDismissBanner={onDismissBanner}
          isDismissed={isDismissed}
          capabilities={bnplCapabilities}
          isLoading={isLoading}
        />
      )}
      {isHomePage ? <BillboardNavigation /> : <CanvasNavigation />}
      <div className={s.layout}>
        {children}
        <CanvasFooter />
      </div>
    </div>
  );
};

export { BillboardLayout };
